<template>
  <div class="container" v-loading="loading">
		<div class="conmonContent">
			<div class="w1600">
				<div class="proTop d-flex j-sb a-start">
					<div class="ptLeft">
						<h3 class="font36 corfff h3">{{ $t('adminMenu.feedback') }}</h3>
					</div>
					<!-- 筛选 -->
					<div class="searchblock">
						<search></search>
					</div> 
				</div>
				 
				 <!-- 主体列表内容 -->
				 <div class="feedback bd10 p3">
					<!-- 步骤 -->
					<div class="setpContent pr">
						<p></p>
						<dl class="d-flex j-center j-sb">
							<dd class="active">
								<figure><span></span></figure>
								{{ $t('feedback.process1') }}
							</dd>
							<dd>
								<figure><span></span></figure>
								{{ $t('feedback.process2') }}
							</dd>
							<dd>
								<figure><span></span></figure>
								{{ $t('feedback.process3') }}
							</dd>
						</dl>
					</div>
					<!-- 表单 -->
					<div class="stepForm">
						<!-- 问题类型 -->
						<div class="sfSlide d-flex j-sb">
							<div class="lTips bd10 d-flex f-colu j-sb">
								<div class="type line-md">
									<h4 class="font-medium font30 h4">{{ $t('feedback.questionType') }}</h4>
									<p class="cor666 font-light">{{ $t('feedback.selectQuestionType') }}</p>
								</div>
								<p class="cor666 font14 font-light">{{ $t('feedback.required') }}</p>
							</div>
							<div class="sfrEnter">
								<dl class="d-flex f-wrap j-sb">
									<dd class="d-flex f-colu">
										<div class="label">{{ $t('feedback.productOrIp') }}<span>*</span></div>
										<div class="enter"  @click="showPop=true">
											<div class="input pointer select">{{ selectPro?.productName||$t('feedback.selectProductName') }}</div>
										</div>
									</dd>
									<dd class="d-flex f-colu">
										<div class="label">{{ $t('feedback.version') }}<span v-if="selectVersition.length>0">*</span></div>
										<div class="enter">
											<select name="" v-model="formData.versionId" class="input" id="">
												<option value="">{{ $t('feedback.selectVersion') }}</option>
												<option :value="item.id" v-for="(item, index) in selectVersition" :key="index">{{item.no}}</option>
											</select>
										</div>
									</dd>
									<dd class="d-flex f-colu">
										<div class="label">{{ $t('feedback.questionType') }}<span>*</span></div>
										<div class="enter">
											<select name="" v-model="formData.type" class="input" id="">
												<option value="">{{ $t('feedback.selectType') }}</option>
												<option :value="item.value" v-for="(item, index) in selectQuestion" :key="index">{{item.label}}</option>
											</select>
										</div>
									</dd>
									<dd class="d-flex f-colu">
										<div class="label">{{ $t('feedback.ExpectedPriority') }}<span>*</span></div>
										<div class="enter">
											<select name="" v-model="formData.costomerPriority" class="input" id="">
												<option value="">{{ $t('commom.selectPlaceholder') }}</option>
												<option :value="item.value" v-for="(item, index) in selectPriority" :key="index">{{item.label}}</option>
											</select>
										</div>
									</dd>
									<!-- <dd class="d-flex f-colu">
										<div class="label">{{ $t('feedback.ExpectedResolutionTime') }}<span>*</span></div>
										<div class="enter">
											<el-date-picker
											v-model="formData.expectedResolutionTime"
											:picker-options="pickerOptions"
											value-format="yyyy-MM-dd"
											format="yyyy-MM-dd"
											type="date"
											:clearable="false"
											:placeholder="$t('commom.selectPlaceholder')">
											</el-date-picker>
										</div>
									</dd> -->
								</dl>
							</div>
						</div>
						<!-- 问题基本资料 -->
						<div class="sfSlide d-flex j-sb">
							<div class="lTips bd10 d-flex f-colu j-sb">
								<div class="type line-md">
									<h4 class="font-medium font30 h4">{{ $t('feedback.basicInformation') }}</h4>
									<p class="cor666 font-light">{{ $t('feedback.tip') }}</p>
								</div>
								<p class="cor666 font14 font-light">{{ $t('feedback.required') }}</p>
							</div>
							<div class="sfrEnter">
								<dl class="d-flex f-wrap j-sb">
									<dd class="d-flex f-colu w100">
										<div class="label">{{ $t('feedback.questionDesc') }}<span>*</span></div>
										<div class="enter">
											<input type="text" v-model="formData.title" class="input  font-light" :placeholder="$t('feedback.titlePlaceholder')">
										</div>
									</dd>
									<dd class="d-flex f-colu w100">
										<div class="label">{{ $t('feedback.content') }}<span>*</span></div>
										<div class="enter">
											<textarea name="" id="" v-model="formData.description" class="input font-light" cols="30" rows="10" :placeholder="$t('feedback.contentPlaceholder')"></textarea>
										</div>
									</dd>
								</dl>
							</div>
						</div>
						<!-- 补充资料 -->
						<div class="sfSlide d-flex j-sb">
							<div class="lTips bd10 d-flex f-colu j-sb">
								<div class="type line-md">
									<h4 class="font-medium font30 h4">{{ $t('feedback.additionalInformation') }}</h4>
									<p class="cor666 font-light">{{ $t('feedback.additionalInformationTip') }}</p>
								</div>
								<p class="cor666 font14 font-light">{{ $t('feedback.required') }}</p>
							</div>
							<div class="sfrEnter">
								<dl class="d-flex f-wrap j-sb">
									<dd class="d-flex f-colu w100">
										<div class="label d-flex ">{{ $t('feedback.attachments') }}</div>
										<div class="enter">
											<div class="fileUpload d-flex f-wrap">
												<div v-show="!formData.file" class="fileBtn pr d-flex f-colu a-center j-center t-center cor999 font-light">
													<input type="file" class="ab opacity0 pointer">
													<img src="@/assets/Icons/add.png" alt="">
													{{ $t('feedback.uploadImage') }}
													<el-upload
													  class="avatar-uploader ab"
													  action="/api/common/file/upload"
													  :multiple="false"
													  :show-file-list="false"
													  :on-success="handleAvatarSuccess"
													  :before-upload="beforeAvatarUpload"
													  :headers="{'InterfaceToken': $store.state.InterfaceToken}">
													</el-upload>
												</div>
												<div class="fileBtn pr" v-show="formData.file">
													<div class="fileName d-flex f-colu a-center j-center">
														<img :src="fileIcon" alt="">
														<p class="cor999 font14">{{fileName}}</p>
													</div>
													<span class="del pointer" @click="formData.file = ''"><img src="@/assets/Icons/del.png" alt=""></span>
												</div>
											</div>
										</div>
									</dd>
								</dl>
							</div>
						</div>
						<!-- 提交 -->
						<div class="submit d-flex j-center"><button @click="submitForm" class="fmBtn pointer t-sion">{{ $t('feedback.submit') }}</button></div>
					</div>
				 </div>
			</div>
		</div>
		<!-- 弹窗提示 -->
		<popup v-show="popupHandle">
			<div class="slot d-flex f-colu j-center a-center line-md">
				<img src="@/assets/Icons/error.png" alt="">
				<div class="required font18" v-html="message"></div>
			</div>
		</popup>

		
		<el-dialog
		title="''"
		:visible.sync="showPop"
		width="60%"
		top="5vh"
		:title="''"
		center>
		<div class="catpop">
			<div class="in d-flex j-center a-center">
				<div class="box d-flex">
					<div class="ctree">
						<el-tree 
						:data="categoryTree" 
						show-checkbox node-key="id"  
						:props="defaultProps" 
						@check="handleNodeCheck" 
						:expand-on-click-node="false" 
						:check-on-click-node="true">
					</el-tree>
					</div>
					<div class="cright d-flex">
						<div class="ctp d-flex a-center">
							<div class="i d-flex a-center">
								<div class="lb">{{$t('feedback.productOrIp')}}</div>
								<div class="inp">
									<el-input v-model="proKey" placeholder=""></el-input>
								</div>
							</div>
							<div class="btns">
								<el-button type="primary" @click="searchPro">{{$t('filter.search')}}</el-button>
								<el-button @click="reset">{{$t('filter.reset')}}</el-button>
							</div>
						</div>
						<div class="cbd">
							<el-table
							:data="proList"
							style="width: 100%">
							<el-table-column :label="$t('commom.select')" width="70" align="center" class-name="ptool">
								<template slot-scope="scope">
									<div @click="selectPro=scope.row">
										<i class="sqr el-icon-check" :class="(selectPro?.id==scope.row.id&&selectPro?.isIpProject==scope.row.isIpProject)?'cur':''">
									</i>
									</div>
								</template>
							</el-table-column>
							<el-table-column
								prop="productName"
								class-name="pname"
								:label="$t('feedback.productName')">
								<template slot-scope="scope">
									<div @click="selectPro=scope.row">{{scope.row.productName}}</div>
								</template>
							</el-table-column>
							
							</el-table>
						</div>
						<div class="cft d-flex">
							<div class="pgs">
								<el-pagination
								:page-size="pageSize"
								:total="total"
								@current-change="searchPro"
								:current-page="pageCur"
								layout="prev, pager, next">
								</el-pagination>
							</div>
							<div class="btns">
								<el-button type="primary" @click="setPro">{{$t('commom.ok')}}</el-button>
								<el-button @click="showPop=false">{{$t('commom.cancel')}}</el-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		</el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Feedback',
  components: {
    
  },
  data() {
    return {
		categoryTree:[],//产品类别
		defaultProps:{
			label:"name",
			children:"children"
		},
		 pickerOptions: {
		  disabledDate(time) {
			return time.getTime() < Date.now() - 8.64e7; //只能选择今天及今天之后的日期
			//return time.getTime() < Date.now() - 8.64e6; //只能选择今天之后的日期，今天的日期也不能选
		  }
		},
		proKey:'',//产品名称搜索
		proList:[],
		pageCur:1,
		pageSize:10,
		total:60,
		selectTemp:[],
		selectAllIds:[],
		selectPro:'',
		showPop:false,//是否显示产品选择弹窗
		showImg: true, // 是否显示图片
		selectProduct: [], // 产品名称
		selectVersition: [], // 版本号
		selectPriority:[],//优先级
		selectQuestion: [], // 问题类型
		formData: {// 提交表单
			type: '', // 类型
			title: '', // 标题
			productId: '', // 产品标题
			productName:'',
			versionId: '', // 版本号
			description: '', // 描述
			costomerPriority:'',//优先级
			expectedResolutionTime:'',//期望解决时间
			file: '' // 附件
		}, 
		uploadImgs: [],
		message: '', // 提示
		popupHandle: false, // 控制提示弹窗是否显示
		loading:null,
		fileIcon: require('@/assets/Icons/fileIcon.svg'),
		fileName: ''
	}
  },
  
  created() {
	  // 获取产品列表
	  this.getCategory();
	  this.getSelectProduct();
	  // 获取问题类型
	  this.getQuestionType();
	  //获取优先级
	  this.getCostomerPriority();
  },
  
  methods: {
	getCostomerPriority(){//获取类别，初始产品列表
		this.$axios.get(`common/getDict?dictType=sys_feedback_priority`)
		  .then(res => {
			  this.selectPriority=res.data;
		  })
		  .catch(err=>{})
	  },
	  getCategory(){//获取类别，初始产品列表
		this.$axios.get(`product/catalogue`)
		  .then(res => {
			  let data = res.data;
			  this.categoryTree = data;
			  this.selectAllIds=this.getChildIds({
				id:'',
				children:data
			  },[]);
			  this.selectTemp=this.selectAllIds;
			  this.searchPro();
		  })
		  .catch(err=>{})
	  },
	  handleNodeCheck(a,b){//选中类别筛选
		var ids=[];
		b.checkedNodes.forEach(i=>{
			if(i.children.length==0){
				ids.push(i.id)
			}
		})
		this.selectTemp=ids.length==0?this.selectAllIds:ids;
		this.searchPro()
	  },
	  
	  getChildIds(obj,result){
		if (!obj.children || obj.children.length === 0) {
			result.push(obj.id);
		} else {
			obj.children.forEach(child => {
				this.getChildIds(child,result);
			});
		}
		return result;
	  },
	  searchPro(){//获取产品列表
		var that=this;
		this.$axios.get(`common/select/product?categoryId=${that.selectTemp.join(',')}&pageNo=${that.pageCur}&productName=${that.proKey}`)
		  .then(res => {
			that.proList = res.data.list;
			that.total=res.data.total;
			that.selectPro='';
			that.formData.productId='';
		  })
		  .catch(err => {})
	  },
	  reset(){
		this.proKey="";
	  },
	  setPro(){//确定选中产品
		var that=this;
		that.formData.productId=that.selectPro.id;
		that.formData.productName=that.selectPro.productName;
		that.formData.isIpProject=that.selectPro.isIpProject;
		that.selectVersition=[];
		that.getSelectVersition(this.formData.productId,that.selectPro.isIpProject);
		that.showPop=false;
	  },
	  // 获取版本号
	  getSelectVersition(id,isIpProject) {
		  this.$axios.get(`common/select/version?productId=${id}&isIpProject=${isIpProject}`)
		  .then(res => {
			  this.selectVersition = res.data;
		  })
		  .catch(err => {})
	  },
	  
	  // 获取问题类型
	  getQuestionType() {
		this.$axios.get(`common/getDict?dictType=sys_feedback_type`)  
		.then(res => {
			this.selectQuestion = res.data;
		})
		.catch(err => {})
	  },
	  
	  // 获取产品列表
	  getSelectProduct() {
		  this.$axios.get('common/select/product')
		  .then(res => {
			  this.selectProduct = res.data;
		  })
		  .catch(err => {})
	  },
	  
	  // 选择产品获取版本号
	  checkedProduct() {
		  let that = this;
		  // 获取版本号
		  this.getSelectVersition(this.formData.productId);
	  },
	  
	  // 头像上传前进行验证
	  beforeAvatarUpload(file) {
		  this.fileName = file.name;
		
	  	// this.beforeAvatarUploadCommon(file,20);
	  },
	  
	  // 上传成功
	  handleAvatarSuccess(response) {
		  if(response.code == 500) {
			  this.$message.error(this.$t('commom.sysErr'))
		  }
		  this.formData.file = response.data;
	  },
	  
	  // 提交
	  submitForm() {
		let that=this;
		  let index = 0;
		  let requred = '';
		  let isPermission=JSON.parse(localStorage.getItem('permissions'));
		  if(!isPermission||!isPermission.includes('isWorkSubmit')){
			  this.popupHandle = true;
			  this.message = this.$t('commom.noPermission');
			  return;
		  };
		  // 产品名称
		  if(!this.formData.productId) {
			  index++;
			  requred+='<p>'+index + ' - ' + this.$t('feedback.enterProductName')+'</p>';
		  }
		  // 版本号
		  if(this.selectVersition.length!=0&&!this.formData.versionId) {
			  index++;
			  requred+='<p>'+index + ' - ' + this.$t('feedback.selectVision')+'</p>';
		  }
		  // 问题类型
		  if(!this.formData.type) {
			  index++;
			  requred+='<p>'+index + ' - ' + this.$t('feedback.selectQuestionType')+'</p>';
		  }
		  // 问题概述
		  if(!this.formData.title.trim()) {
			  index++;
			  requred+='<p>'+index + ' - ' + this.$t('feedback.writeQuestion')+'</p>';
		  }
		  // 详细描述
		  if(!this.formData.description.trim()) {
			  index++;
			  requred+='<p>'+index + ' - ' + this.$t('feedback.writeDetail')+'</p>';
		  }
		  if(index > 0) {
			  this.popupHandle = true;
			  this.message = requred;
			  return;
		  };
		  const submitloading=that.$loading({
				lock: true,
				text: 'Loading',
				background: 'rgba(0, 0, 0, 0.3)',
		  });
		  that.$axios.post('form/feedback', that.formData)
		  .then(res => {
			that.$message({
				message:that.$i18n.locale=='zh_CN'?res.cnMessage:res.enMessage,
				type:res.code==200?'success':'error'
			});
            that.formData.type = ''; // 类型
            that.formData.title = ''; // 标题
            that.formData.productId = ''; // 产品标题
            that.formData.productName = ''; // 产品标题
            that.formData.versionId = ''; // 版本号
            that.formData.description = ''; // 描述
            that.formData.file = ''; // 附件
			submitloading.close();
			that.$router.push('/problemFeedback');
		  })
		  .catch(err => {
			submitloading.close();
		})
	  }
  }
}
</script>

<style lang="less" scoped>
	/deep/ .el-date-editor
	{
		display: block;
		width: auto !important;
		.el-input__inner{
			color: #333;
			border:none;
			font-size: 0.16rem;
			font-family: "Regular", "arial", "sans-serif";
			outline: none;
			border-radius: 5px;
			padding: 0 0.2rem;
			width: 100%;
			height: 0.5rem;
			padding-right: .5rem;
			background: #f5f6f8 url(@/assets/Icons/arrowDownWeight.png) no-repeat 95% center/0.1rem;
		}
		.el-input__prefix{
			display: none;
		}
	}
	
	.stepForm{
		.sfSlide{
			margin-bottom: .4rem;
		}
		.submit{
			margin-top: .6rem;
			button{
				width: 1.2rem;
			}
		}
		.lTips{
			width: 3.4rem;
			
			padding: .6rem .4rem;
			background: #eceef1;
			h4{
				color: #2657db;
			}
		}
		.sfrEnter{
			width: calc(100% - 3.9rem);
			border-bottom: solid 1px #eee;
			.fileUpload{
				margin-top: -.2rem;
				.fileBtn{
					width: 1.6rem;
					height: 1.6rem;
					margin-right: .2rem;
					margin-top: .2rem;
					.fileName{
						width: 1.5rem;
						height: 1.5rem;
						line-height: 1.5;
						p{
							margin-top: .2rem
						}
						img{
							max-width: .6rem;
						}
					}
					.del{
						position: absolute;
						right: .1rem;
						top: .1rem;
						width: .2rem;
						z-index: 3;
					}
					&:nth-of-type(1) {
						img{
							width: .3rem;
							margin-bottom: .15rem;
						}
						background: #f5f6f8;
					}
				}
			}
			dl{
				margin: 0 0 0 .4rem;
				max-width: 8.8rem;
				dd{
					width: 46%;
					margin-bottom: .2rem;
					margin-top: 0.2rem;
					&.w100{
						width: 100%;
					}
					textarea{
						height: 1.2rem;
						padding: .2rem;
					}
					.label{
						margin-bottom: .2rem;
						align-items: baseline;
						i{
							margin-left: .1rem;
						}
						span{
							margin-left: .1rem;
							color: #2e70e2;
						}
					}
				}
			}
		}
		@media (max-width: 640px) {
			.sfSlide{
				display: block;
			}
			.lTips{
				padding: .2rem;
				height: auto;
				width: 100%;
			}
			.sfrEnter{
				width: 100%;
				dl{
					margin-left: 0;
					dd{
						width: 100%;
						margin-top: .2rem;
					}
				}
			}
		}
	}
	.feedback{
		padding-bottom: 1rem;
		.setpContent{
			max-width: 9.5rem;
			margin: .3rem auto .7rem;
			p{
				position: absolute;
				left: 0;
				top: .35rem;
				width: 100%;
				height: 4px;
				background: #eceef1;
			}
			dl{
				position: relative;
				z-index: 3;
				dd{
					width: .7rem;
					text-align: center;
					&.active {
						figure{
							background-image: url(@/assets/Question/stepBgBlue.png);
						}
						color: #294ad3;
					}
					&:nth-of-type(1) {
						&.active{
							figure span{
								background-image: url(@/assets/Icons/step4.png);
							}
						}
						figure span{
							 background: url(@/assets/Icons/step1.png) no-repeat .22rem center/auto .3rem;
						}
					}
					&:nth-of-type(2) {
						&.active{
							figure span{
								background-image: url(@/assets/Icons/step5.png);
							}
						}
						figure span{
							 background: url(@/assets/Icons/step2.png) no-repeat .23rem center/auto .3rem;
						}
					}
					&:nth-of-type(3) {
						&.active{
							figure span{
								background-image: url(@/assets/Icons/step6.png);
							}
						}
						figure span{
							 background: url(@/assets/Icons/step3.png) no-repeat .22rem center/auto .36rem;
						}
					}
					figure{
						background: #fff url(@/assets/Question/stepBg.png) no-repeat center/100% 100%;
						margin-bottom: .15rem;
						span{
							display: block;
							height: .7rem;
						}
					}
				}
			}
		}
	}
	.proTop{
		padding: .5rem 0;
		.tags{
			span{
				display: inline-block;
				padding: 0.05rem 0.08rem;
				border-radius: 0.15rem;
				background: #5794f8;
				color: #fff;
				margin-right: .1rem;
			}
		}
		.cTopFrom{
			margin: 0;
		}
		@media (max-width: 1200px) {
			display: block;
			.cTopFrom{
				margin: .3rem auto 0;
			}
		}
	}
	/deep/.el-dialog__header {
		display: none;
	}
	/deep/ .el-dialog__body{
		font-size: inherit;
		font-family: inherit;
		padding-top: 0 !important;
   		padding-bottom: 0 !important;
	}
	/deep/.el-pager li{
		background: none;
		font-size: 16px;
		font-weight: normal;
	}
	.catpop .cright .sqr {
    display: inline-block;
    width: 16px;
    height: 16px;
    vertical-align: middle;
    border: 1px solid #ccc;
    cursor: pointer;
	color: transparent;
	transition: .3s;
	line-height: 12px;
    text-align: center;
}

.catpop .cright .sqr.cur {
    border-color: #409eff;
	background: #409eff;
	color: #fff;
}
.catpop .cright .sqr::before{
	font-size: 12px;
}
.catpop .in {
    width: 100%;
    height: 100%;
}

.catpop .box {
    width: 100%;
    background: #fcfcfc;
    height: 80vh;
    align-items: stretch;
}

.ctree {
    flex: 0 0 auto;
    width: 300px;
    padding: 30px 20px 20px 0;
	overflow: auto;
	background: #fff;
}
.el-tree{
	background: none;
}
.ctree /deep/ .el-tree-node__content {
    height: 40px;
}

.ctree /deep/ .el-tree-node__label {
    font-size: 16px;
}
.catpop .cright {
    flex: 1 1 auto;
	flex-direction: column;
    padding: 30px;
    overflow: hidden;
}
.catpop .cright .ctp{
	width: 100%;
	flex: 0 0 auto;
}
.catpop .cright .btns {
    margin-left: 10px;
}

.catpop .cright .lb {
    padding-right: 10px;
}

.catpop .cright .ctp input {
    background: #eceff6;
    width: 300px;
}

.catpop .cright .cbd {
    margin: 20px 0;
	flex: 1 1 auto;
	width: 100%;
	background: #fff;
	overflow: auto;
}
/deep/.pname .cell {
    padding-left: 30px;
    position: relative;
	text-align: left;
}

/deep/td.pname .cell:before {
    content: "";
    width: 4px;
    height: 4px;
    position: absolute;
    left: 15px;
    top: 50%;
    margin-top: -2px;
    background: #409eff;
}

/deep/.el-table .el-table__cell.pname {
    padding-top: 0;
    padding-bottom: 0;
	.cell>div{
		padding-top: 20px;
    padding-bottom: 20px;
	@media (max-width:768px) {
		padding-top: 10px;
		padding-bottom: 10px;
	}
	}
}
/deep/.el-table .el-table__cell.ptool {
    padding-top: 0;
    padding-bottom: 0;
	.cell>div{
		padding-top: 20px;
    padding-bottom: 20px;
	@media (max-width:768px) {
		padding-top: 10px;
		padding-bottom: 10px;
	}
	}
}
.catpop .cright /deep/ .el-table th.el-table__cell {
    background: #e3e8ee;
    text-align: center;
    color: #002e8a;
	font-weight: normal;
	padding-top: 12px;
	padding-bottom: 12px
}

.catpop .cright .el-table  * {
    font-family: inherit;
    font-size: inherit;
    font-weight: normal;
}
.catpop /deep/ .el-tree-node__content {
    position: relative;
	background: none !important;
}

.catpop /deep/ .el-tree-node__expand-icon {
    position: absolute;
    right: 0;
}
.cright .el-table {
    font-size: inherit;
}

.catpop .cright .cft {
    align-items: center;
    justify-content: space-between;
	width: 100%;
	flex: 0 0 auto;
}
.ctree::-webkit-scrollbar,.selects::-webkit-scrollbar{width:4px;height:1px;}
.ctree::-webkit-scrollbar-thumb{border-radius:4px;-webkit-box-shadow:inset 0 0 5px rgba(0,0,0,0.1);background:#264f8c;}
.ctree::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 5px rgba(0,0,0,0.2);border-radius:10px;background:#f2f2f2;}
.input{
	line-height: 0.5rem;
}
@media(max-width:768px){
	.catpop .box {
    display: block;
    overflow: auto;
    background: #fff;
    padding: 20px;
}

.ctree {
    width: auto;
    padding: 20px 0;
}

.catpop .cright {
    padding: 0;
}

/deep/.el-button {
    padding: 5px 10px;
    font-size: 12px;
}

.catpop .cright .ctp {
    display: block;
}

.catpop .cright .btns {
    text-align: right;
    margin-top: 10px;
    margin-left: 0;
}

.catpop .cright .ctp .inp {
    flex: 1;
}

.catpop .cright .ctp input {
    height: 30px;
}

/deep/.el-table .el-table__cell:nth-child(2), colgroup col:nth-child(2) {
    width: 40px !important;
}

/deep/.el-table .el-table__cell.pname {
    padding-top: 10px;
    padding-bottom: 10px;
}

.catpop .cright .cft {
    display: block;
}

/deep/.el-dialog--center .el-dialog__body {
    padding: 0;
}


.ctree /deep/.el-tree-node__content {
    height: 30px;
}

.ctree /deep/.el-tree-node__label {
    font-size: 14px;
}

/deep/.el-pager li {
    font-size: 14px;
}
/deep/.el-dialog{
	min-width: 90%;
}
}
</style>
